import { Pipe, PipeTransform } from '@angular/core';
import { getCountryName, isInternationalCountry, SUPPORTED_COUNTRY_CODES } from 'core/geography';
import { isNullOrWhitespace } from 'helpers';
import { negate } from 'lodash-es';
import { isNil } from 'lodash-es';
/*
 * Returns friendly address string
*/
@Pipe({ name: 'address' })
export class AddressPipe implements PipeTransform {
  transform(value: any): string {
    if (isNil(value)) {
      return '';
    }

    const hasValue: (v: string) => boolean = negate(isNullOrWhitespace);
    const address = value as { streetAddress: string; city: string; state: string; zip: string, country: string; };
    let result = '';
    if (isInternationalCountry(address.country)) {
      // International addresses have no state, so include the country for Google Maps
      // (UK instead of GB, full name for the rest)
      const country = address.country == SUPPORTED_COUNTRY_CODES.UK ? 'UK' : getCountryName(address.country);
      result = [address.streetAddress, address.city, address.zip, country]
        .filter(p => hasValue(p))
        .join(', ');
    } else {
      result = [address.streetAddress, address.city, address.state, address.zip]
        .filter(p => hasValue(p))
        .join(', ');
    }

    return result;
  }
}
